import { CUSTOMER_STATUS } from '@/modules/Customer/constants'
import { SearchResultType } from '../types'

export const SEARCH_RESULT_TYPES: Record<
    SearchResultType,
    { label: string; icon: string; color: string }
> = {
    customer: {
        label: 'customer',
        icon: 'CheckIcons',
        color: 'primary',
    },
    service: {
        label: 'service',
        icon: 'WatchIcons',
        color: 'success',
    },
    invoice: {
        label: 'invoice',
        icon: 'WatchIcons',
        color: 'warning',
    },
    contract: {
        label: 'contract',
        icon: 'WatchIcons',
        color: 'info',
    },
}

export const SEARCH_RESULT_STATUS = {
    contact: {
        [CUSTOMER_STATUS.COOLLEAD]: { label: 'Cool Lead', color: 'warning' },
        [CUSTOMER_STATUS.POC]: { label: 'POC', color: 'info' },
        [CUSTOMER_STATUS.QUALIFIED_PROSPECTS]: {
            label: 'Khách hàng tiềm năng',
            color: 'error',
        },
        [CUSTOMER_STATUS.TRIAL]: { label: 'Dùng thử', color: 'info' },
        [CUSTOMER_STATUS.STOP]: {
            label: 'Khách hàng ngừng hoạt động',
            color: 'default',
        },
        [CUSTOMER_STATUS.ACTIVE]: {
            label: 'Khách hàng đã khai thác',
            color: 'success',
        },
    },
    customer: {
        lead: { label: 'Tiềm năng', color: 'warning' },
        trial: { label: 'Dùng thử', color: 'info' },
        official: { label: 'Chính thức', color: 'success' },
    },
    service: {
        active: { label: 'Hoạt động', color: 'success' },
        inactive: { label: 'Ngừng hoạt động', color: 'error' },
        suspended: { label: 'Tạm ngừng', color: 'warning' },
    },
    invoice: {
        paid: { label: 'Đã thanh toán', color: 'success' },
        unpaid: { label: 'Chưa thanh toán', color: 'warning' },
        overdue: { label: 'Quá hạn', color: 'error' },
        cancelled: { label: 'Đã hủy', color: 'default' },
    },
    contract: {
        draft: { label: 'Bản nháp', color: 'default' },
        signed: { label: 'Đã ký', color: 'success' },
        expired: { label: 'Hết hạn', color: 'error' },
        cancelled: { label: 'Đã hủy', color: 'default' },
    },
}

export const SEARCH_DEBOUNCE_DELAY = 300 // ms
export const SEARCH_MIN_QUERY_LENGTH = 2
export const SEARCH_MAX_RESULTS = 50
export const SEARCH_RECENT_LIMIT = 10
